import Starring from './Starring';

export default Starring;
